module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "configuration-view-wrapper new-company"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('companies.actions.create')))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.name')))]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.company.name),
      expression: "company.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "name", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    key: "name",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('email_domain')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "email_domain"
    }
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.emailDomain')))]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.company.email_domain),
      expression: "company.email_domain"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email_domain",
      "name": "email_domain",
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.email_domain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "email_domain", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "email_domain": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email_domain')),
      expression: "errors.has('email_domain')"
    }],
    key: "email_domain",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('email_domain')))])])], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "account_setting"
    }
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.plan')))]), _c('dropdown-select', {
    staticClass: "field",
    attrs: {
      "id": "account_setting",
      "options": _vm.company.account_setting_options().account_settings,
      "selected": _vm.account_setting_selected
    },
    model: {
      value: (_vm.account_setting_selected),
      callback: function($$v) {
        _vm.account_setting_selected = $$v
      },
      expression: "account_setting_selected"
    }
  })], 1), (_vm.account_setting_selected && _vm.account_setting_selected.name == "custom") ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('max_number_of_regular_users')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "max_number_of_regular_users"
    }
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.maxUsersCount')))]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.account_setting.max_number_of_regular_users),
      expression: "account_setting.max_number_of_regular_users"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "max_number_of_regular_users",
      "name": "max_number_of_regular_users",
      "type": "text"
    },
    domProps: {
      "value": (_vm.account_setting.max_number_of_regular_users)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account_setting, "max_number_of_regular_users", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "max_number_of_regular_users": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('max_number_of_regular_users')),
      expression: "errors.has('max_number_of_regular_users')"
    }],
    key: "max_number_of_regular_users",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('max_number_of_regular_users')))])])], 1) : _vm._e(), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('max_number_of_monitoring_managers')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "max_number_of_monitoring_managers"
    }
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.maxManagersCount')))]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.account_setting.max_number_of_monitoring_managers),
      expression: "account_setting.max_number_of_monitoring_managers"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "max_number_of_monitoring_managers",
      "name": "max_number_of_monitoring_managers",
      "type": "text"
    },
    domProps: {
      "value": (_vm.account_setting.max_number_of_monitoring_managers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account_setting, "max_number_of_monitoring_managers", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "max_number_of_monitoring_managers": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('max_number_of_monitoring_managers')),
      expression: "errors.has('max_number_of_monitoring_managers')"
    }],
    key: "max_number_of_monitoring_managers",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('max_number_of_monitoring_managers')))])])], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "account_setting"
    }
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.emailService')))]), _c('email-service-dropdown', {
    model: {
      value: (_vm.company.email_service),
      callback: function($$v) {
        _vm.$set(_vm.company, "email_service", $$v)
      },
      expression: "company.email_service"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email_service')),
      expression: "errors.has('email_service')"
    }],
    key: "email_service",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('email_service')))])])], 1)])]), _c('div', {
    staticClass: "clear"
  }), _c('br'), _c('router-link', {
    staticClass: "btn btn-gray",
    attrs: {
      "to": "/configuracoes/empresas"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38432390!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/companies/new.vue
// module id = 1074
// module chunks = 1